<template>
	<div class="row">
		<div class="col-md-12 mb-2">
			<h4>REPORT B2B</h4>
		</div>
		<div class="col-md-12">
			<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
				<div class="row">
					<div class="col-md-12">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane name="transaction">
								<span slot="label"><i class="el-icon-data-line"></i> Transaction</span>
								<div class="px-0 tab-container-item">
									<B2BReport :tabIndex="0" :tabName="'b2b-transaction'" :tabLabel="'Transaction'"/>
								</div>
							</el-tab-pane>
							<el-tab-pane name="customer">
								<span slot="label"><i class="el-icon-data-line"></i> Top 10 Customer</span>
								<div class="px-0 tab-container-item">
									<B2BReport :tabIndex="0" :tabName="'b2b-customer'" :tabLabel="'Customer'"/>
								</div>
							</el-tab-pane>
							<el-tab-pane name="item">
								<span slot="label"><i class="el-icon-data-line"></i> Top 10 Item</span>
								<div class="px-0 tab-container-item">
									<B2BReport :tabIndex="0" :tabName="'b2b-item'" :tabLabel="'Item'"/>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</el-card>

		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import $ from 'jquery';

import B2BReport from '@/views/pages/B2B/Component/B2BReport.vue'

export default{
	extends: Fuel,
	components:{
		B2BReport,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
            value: 0,
			activeName: 'transaction',

			outterheight: 160,
			screenHeight: window.innerHeight - 160,
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted(){
		this.$emit('childrenRoute');
		this.addTabNavClass();
		window.addEventListener('resize', this.setDivHeight);
    },
	beforeDestroy() {
        window.removeEventListener('resize', this.setDivHeight);
    },
    methods:{
		setDivHeight() {
          this.screenHeight = window.innerHeight - this.outterheight;
        },
		addTabNavClass() {
			$(".el-tabs__nav-wrap").addClass("bg-white");
			$(".el-tabs__header").addClass("tab-nav");
		},
		handleClick(tab, event) {
			console.log(tab, event);
		}
	}
}
</script>

<style>
.tab-nav {
	background: #ffffff !important;
	margin-bottom: 0px !important;
}

.tab-container-item {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>